import { useQuery } from "react-query";

import { makeSimpleGetRequest, makeSimplePatchRequest } from "lib/axios";
import { ORDERBOOK_URL } from "services/constants";
import { PaymentRequest } from "services/paymentRequests/types";

const getPaymentRequestByToken = async (
  token: string,
): Promise<PaymentRequest> => {
  const response = await makeSimpleGetRequest<PaymentRequest>(
    `${ORDERBOOK_URL}/payment-requests/${token}/?include[]=buyer.*`,
  );
  return response;
};

export const updatePaymentRequest = async (
  id: string,
  payload: Partial<PaymentRequest>,
): Promise<PaymentRequest> => {
  return await makeSimplePatchRequest<PaymentRequest>(
    `${ORDERBOOK_URL}/payment-requests/${id}/`,
    JSON.stringify(payload),
    [200],
  );
};

export const usePaymentRequestByToken = (token: string) => {
  return useQuery(
    ["paymentRequestByToken", token],
    () => getPaymentRequestByToken(token),
    {
      enabled: !!token,
      retry: false,
    },
  );
};
